import React from 'react'; // 引入react
import { Route, IndexRedirect } from 'react-router'; // 引入react路由

import app from './containers/app';
import Error from './containers/error';
// 任务管理
import taskManage from './containers/taskManage';
import taskManageFirstPage from './containers/taskManage/firstPage';
import taskManageMonitoring from './containers/taskManage/monitoring';
import taskManageList from './containers/taskManage/list';
import taskManageDetail from './containers/taskManage/detail';
import taskManageStatistic from './containers/taskManage/statistic';
import taskManageQuestionNaire from './containers/taskManage/questionNaire';
import interactivePath from './containers/taskManage/interactivePath';
// 系统设置
import systemSetting from './containers/systemSetting';
import workTime from './containers/systemSetting/workTime';
import talkingSkill from './containers/systemSetting/talkingSkill';
import callingNumber from './containers/systemSetting/callingNumber';
import exportTasks from './containers/systemSetting/exportTasks';
import newRole from './containers/systemSetting/roleManagement';
import userManage from './containers/systemSetting/userManagement';
import soundMarket from './containers/systemSetting/soundMarket';
// 任务配置
// import enterpriseConfig from './containers/enterpriseConfig';
// import enterpriseConfig from './containers/enterpriseConfig/enterpriseConfig';
// AI优化
import ai from './containers/ai';
import questionStudy from './containers/ai/questionStudy';
import enterpriseConfig from './containers/ai/enterpriseConfig';

import oauth from './components/oauth';
import refresh from './components/oauth/refresh';
// import { getUserInfo } from 'Utils';

const requireAuth = async () => {
  // const user = localStorage.getItem('user');

  // manager.events.addAccessTokenExpiring(() => {
  //   manager
  //     .getUser()
  //     .then(user => {
  //       if (user) {
  //         user = JSON.stringify(user);
  //         localStorage.setItem('user', user);
  //       } else {
  //         manager.signinRedirect();
  //       }
  //     })
  //     .catch(() => {
  //       manager.signinRedirect();
  //     });
  // });
  // if (!user) {
  //   if (window.top === window) {
  //     manager.signinRedirect();
  //   } else {
  //     getUserInfo()
  //   }
  // }
};
export default (
  <Route path="/">
    {/* {route} */}
    <IndexRedirect to='/taskManage' />
    <Route path="oauth" component={oauth} />
    <Route path="refresh" component={refresh} />
    <Route component={app} onEnter={requireAuth}>
      <Route path="error" component={Error} />
      <Route path="taskManage" component={taskManage}>
        {/* <IndexRoute component={taskManageFirstPage} /> */}
        <Route path="firstPage" component={taskManageFirstPage} />
        <Route path="monitoring" component={taskManageMonitoring} />
        <Route path="list" component={taskManageList} />
        <Route path="detail" component={taskManageDetail} />
        <Route path="statistic" component={taskManageStatistic} />
        <Route path="questionNaire" component={taskManageQuestionNaire} />
        <Route path="interactivePath" component={interactivePath} />
      </Route>
      <Route path="systemSetting" component={systemSetting}>
        {/* <IndexRoute component={workTime} /> */}
        <Route path="workTime" component={workTime} />
        <Route path="talkingSkill" component={talkingSkill} />
        <Route path="callingNumber" component={callingNumber} />
        <Route path="exportTasks" component={exportTasks} />
        {/* <Route path="exportTasks" component={exportTasks} /> */}
        <Route path="newRole" component={newRole} />
        <Route path="user" component={userManage} />
        <Route path="soundMarket" component={soundMarket} />
      </Route>
      <Route path="ai" component={ai}>
        {/* <IndexRoute component={questionStudy} /> */}
        <Route path="questionStudy" component={questionStudy} />
        <Route path="enterpriseConfig" component={enterpriseConfig} />
      </Route>
      <Route path="newRoleManage" component={newRole} />
      <Route path="userManage" component={userManage} />
      {/* <Redirect from="*" to="taskManage/firstPage" /> */}

    </Route>

  </Route>
);
